import styled from 'styled-components';

// App Container Styles
export const AppContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.color.gray[100]};
  display: flex;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
`;

export const MainContent = styled.main`
  flex: 1;
  padding: 2rem;
  background-color: ${({ theme }) => theme.color.gray[100]};
  min-width: 0;
  overflow-y: auto;
  overflow-x: auto;
`;
